(function($) {
	// load all folios on document.ready if they have a filter
	$('.mini-folio').each(function(){
		if ($(this).find('.mini-folio__filter').length) {
			loadFolio($(this));
		}
	});

	// load all folios on history back/forward
	window.onpopstate = function(event) {
		$('.mini-folio').each(function(){
			if ($(this).find('.mini-folio__filter').length) {
				loadFolio($(this));
			}
		});		
	}

	$('.mini-folio').on('click','.mini-folio__filter__item',function(){
		var folio = $(this).closest('.mini-folio');	
		var targetPos = folio.find('.mini-folio__items').offset().top - $('.header__top').outerHeight();			

		if ($(this).hasClass('mini-folio__filter__item--reset')) {
			$('.mini-folio__filter__item').removeClass('active');
			targetPos = folio.offset().top - $('.header__top').outerHeight();
		} else {			
			$(this).toggleClass('active');						
		}

		if (Math.abs(targetPos - $(window).scrollTop()) > 50) { // scroll folio into view position
			$('html, body').animate({
	          scrollTop: targetPos - 20
		    });
		}

		filterFolio(folio,false);
	});

	function filterFolio(folio,onLoad) {
		$('.no-results').remove();
		var items = folio.find('.mini-folio__items > *');
		var activeTags = folio.find('.mini-folio__filter__item.active');
		console.log('filtering folio...','onLoad: '+onLoad);
		if (activeTags.length) {			
			items.each(function(){
				var itemTags = $(this).data('tags');
				var show = true;
				activeTags.each(function(){
					if (itemTags.indexOf($(this).text()) == -1) {
						show = false;
					}
				});
				$(this).toggle(show);
			});
			if (!folio.find('.mini-folio__items > *:visible').length) {
				$('.mini-folio__items').append('<h3 class="no-results">Sorry, try a different combo!</h3><div class="mini-folio__filter__item mini-folio__filter__item--reset no-results">Reset</div>');
			}
			// push history of tags filtered if not onLoad
			if (!onLoad) {
				var tagQuery = '';
				activeTags.each(function(){
					tagQuery += encodeURI($(this).text())+',';
				});
				history.pushState(null, null, "?tags="+tagQuery)
			}
		} else {
			items.show();
			if (!onLoad) {
				history.pushState(null, null, "/portfolio/");
			}
		}
	}

	function loadFolio(folio) {
		var urlParams = new URLSearchParams(window.location.search);
		var tagQuery = urlParams.get('tags');
		$('.mini-folio__filter__item').removeClass('active');
		if (tagQuery) {
			var tags = tagQuery.split(',');
			$.each(tags,function(index,item) {
				if (item!='') {
					$('.mini-folio__filter__item:contains("'+item+'")').addClass('active');
				}
			});	
			$('html, body').animate({
	          scrollTop: $('.mini-folio__items').offset().top - $('.header__top').outerHeight() - 20
		    });		
		}
		filterFolio(folio,true);
	}

})( jQuery );  